import React from 'react';
import './styles.css';





export const JuegoParrafoConSangria = ( props ) => {


  return (
    <>


        <div className='JuegoParrafoConSangria-Principal-Container'>

                    {props.JuegoParrafoConSangriaTexto}
                    
        </div>


    </>
  )
}
